import LegalPage from "@/components/site/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      eyebrow="Privacy"
      title="Data Privacy & Security"
      intro="At Contentium Tech, we are committed to protecting the privacy of our users — handling personal data responsibly, transparently, and securely."
      downloadUrl="https://contentiumtech.com/Contentium_Tech_Privacy_Policy_v1.0.pdf"
      sections={[
        {
          id: "data-privacy",
          heading: "Data Privacy",
          body: [
            "At Contentium Tech, we are committed to protecting the privacy of our users and ensuring that personal data is handled responsibly, transparently, and securely.",
            "We collect only the minimum necessary information required to deliver our services effectively, such as contact details and learning-related inputs, and use it solely for intended purposes.",
            "We do not sell, rent, or share personal data with third parties without explicit consent, except where required by law or for essential service delivery.",
            "Our practices are aligned with the principles of the Digital Personal Data Protection Act, 2023 (India), ensuring lawful processing, purpose limitation, and user rights protection.",
            "Users retain the right to access, correct, or request deletion of their personal data by contacting us directly.",
          ],
        },
        {
          id: "children-privacy",
          heading: "Children's Privacy & Parental Responsibility",
          body: [
            "Eduzy, a learning initiative by Contentium Tech, may involve interaction with students, including minors. We recognize the importance of safeguarding children's data and ensuring responsible usage of our platform.",
            "We do not knowingly collect personal data from children without the involvement and consent of a parent or legal guardian. Any information shared on behalf of a student is assumed to be provided by an authorized adult.",
            "Parents and guardians are responsible for supervising the information shared by their children and for ensuring that only accurate and necessary details are provided during registration or interaction with our services.",
            "Contentium Tech shall not be held liable for any incorrect, excessive, or inappropriate information shared by users without parental oversight.",
            "We encourage parents to actively monitor their child's engagement and to contact us for any concerns regarding data usage, privacy, or content.",
          ],
        },
        {
          id: "data-security",
          heading: "Data Security",
          body: [
            "Contentium Tech implements industry-standard security measures to safeguard user data against unauthorized access, disclosure, or misuse.",
            "We use secure systems, controlled access mechanisms, and encryption practices where applicable to ensure data integrity and confidentiality.",
            "Access to sensitive data is restricted to authorized personnel only and is monitored to prevent misuse or unauthorized handling.",
            "We continuously review and improve our security practices to stay aligned with evolving threats and regulatory expectations.",
            "Our goal is to build trust by ensuring that all user interactions with our platform are safe, secure, and reliable.",
          ],
        },
      ]}
    />
  );
}
